export enum ColorSchemeType {
  EXTERNAL = "external",
  INTERNAL = "internal",
}
